<template>
    <v-container class="message-scroll px-12 py-12 fci-scrollbar">
        <!-- Summary Section -->
        <v-layout>
            <div>
                <h2>{{ $f.tc('summary') }}</h2>
                <div>
                    <p v-for="(line, indexLine) in formattedTextSummary(callSummary)" :key="indexLine">{{ line }}</p>
                </div>
            </div>
        </v-layout>

        <!-- Criteria Section -->
        <v-layout v-if="analysisList.length > 0">
            <div>
                <h2>{{ $f.tc('criteria') }}</h2>
                <div v-for="(item, index) in analysisList" :key="index">
                    <v-card>
                        <v-card-title>
                            <h3> {{ item['input']['label'] }}</h3>
                        </v-card-title>
                        <v-card-text>
                            <p v-for="(line, indexLine) in formattedText(item)" :key="indexLine">
                                {{ line }}
                            </p>
                        </v-card-text>
                    </v-card>
                </div>
            </div>
        </v-layout>
    </v-container>
</template>

<script>

import CampaignService from "@/services/campaign.service";
import {mapState} from "vuex";

export default {
    name: "CampaignHistoryOverview",
    data() {
        return {
            analysisList: []
        }
    },
    props: {
        activeCallId: {
            type: String,
            default: () => ''
        },
        callSummary: {
            type: String,
            default: () => ''
        },
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
        }),
        callId() {
            return this.$route.query.call_id || ''
        }
    },
    mounted() {
        this.loadCallAnalysis()
    },
    methods: {
        loadCallAnalysis() {
            // load analysis
            CampaignService.getAnalysisCall(this.campaign.id, this.callId).then(
                result => {
                    this.analysisList = result.data.filter(item => Object.keys(item.output).length > 0)
                }
            )
        },
        formattedText(item) {
            let output = item?.output
            let text = this.$f.tc('noDataAvailable')
            if (!!output) {
                text = output.text ? output.text : ''
            }
            return text.split('\n');
        },
        formattedTextSummary(text) {
            return text.split('\n');
        }
    },
    watch: {
        callId: 'loadCallAnalysis'
    }
}
</script>

<style scoped lang="scss">
@import "../Scenario/chat.scss";

.message-scroll {
    height: calc(100vh - 295px);
    overflow: auto;
}

.v-card__title {
    padding: 16px 0 0 16px;
}

.call-audio {
    display: flex;
    align-items: center;

    audio {
        width: 100%;
        height: 30px;
    }
}

</style>
